import { ItemQuestion, Question, QuestionTrueFalse } from "@/models/quiz.model";
import { defineStore } from "pinia";
import { instance } from "./index";

export enum QuestionType {
  DEFAULT,
  DRAG_AND_DROP,
  TRUE_OR_FALSE,
  FILL_IN_THE_BLANKS,
}

const store = defineStore({
  id: "quiz-questions",
  state: () => ({
    form: {
      id: "",
      prompt: "",
      items: [] as any,
    } as any,
    selectCorrect: false as boolean,
    isAdaptive: false as boolean,
    v$: {} as any,
  }),
  getters: {
    getForm: (state) => state.form,
    getFormItems: (state) => state.form.items,
    getSelectCorrect: (state) => state.selectCorrect,
    getIsAdaptive: (state) => state.isAdaptive,
    getV: (state) => state.v$,
  },
  actions: {
    setForm(value: Question | QuestionTrueFalse) {
      this.form = value;
    },
    setFormItems(value: Array<ItemQuestion>) {
      this.form.items = value;
    },
    setSelectCorrect(value: boolean) {
      this.selectCorrect = value;
    },
    setIsAdaptive(value: boolean) {
      this.isAdaptive = value;
    },
    setV(value: any) {
      this.v$ = value;
    },
  },
});

export const useQuizQuestionsStore = store(instance);
